<template>
  <SearchLayout :kind="layout">
    <div class="tabs is-fullwidth is-boxed">
      <ul>
        <router-link
          tag="li"
          :to="{ name: 'Search' }"
          icon="fa-align-left"
          active-class="is-active"
          exact
          ><a>Text <b-icon icon="align-left" size="is-small"> </b-icon></a
        ></router-link>
        <router-link
          tag="li"
          :to="{ name: 'Tags' }"
          icon="fa-tags"
          active-class="is-active"
          exact
          ><a>Tags <b-icon icon="tags" size="is-small"> </b-icon></a
        ></router-link>
        <router-link
          tag="li"
          :to="{ name: 'Metadata' }"
          icon="fa-database"
          active-class="is-active"
          exact
          ><a>Metadata <b-icon icon="database" size="is-small"> </b-icon></a
        ></router-link>
      </ul>
    </div>
    <template #sidebar>
      <SearchSidebar>
        <SearchFacets />
      </SearchSidebar>
    </template>
    <div class="columns">
      <div
        class="column"
        v-for="option in facets.meta"
        :key="option.facet_field"
      >
        <b-button
          icon-left="filter"
          @click="openModal(option, facetLable(option))"
          >{{ facetLableSelect(option) }}</b-button
        >
      </div>
    </div>

    <header style="margin-bottom: 0.75rem;">
      <div v-if="total > 0" style="margin-bottom: 0.75rem">
        <strong>{{ total }} {{ $t("Documents found") }}</strong>
      </div>
      <b-pagination
        v-if="pagesTotal > 1"
        :total="total"
        :current.sync="currentPage"
        :range-before="3"
        :range-after="4"
        order="is-right"
        :per-page="itemsPerPage"
        icon-prev="chevron-left"
        icon-next="chevron-right"
      />
    </header>
  <div class="card"  v-for="(result, index) of results"  :key="index">
    <div class="card-header" role="button">
          <p class="card-header-title">
            <RouterLink
              :to="{ name: 'Document', params: { documentId: result.docId } }"
            >
              {{ result.title }}
            </RouterLink>
          </p>
        
        </div>
  </div>
    <!-- <b-collapse
      class="card"
      animation="slide"
      v-for="(result, index) of results"
      :key="index"
      :open="isOpen == index"
      @open="isOpen = index"
    >
        <div class="card-header" role="button">
          <p class="card-header-title">
            <RouterLink
              :to="{ name: 'Document', params: { documentId: result.docId } }"
            >
              {{ result.title }}
            </RouterLink>
          </p>
        
        </div>
    </b-collapse> -->
  </SearchLayout>
</template>

<script>
import SearchLayout from "@/components/SearchLayout.vue";
import SearchSidebar from "@/components/SearchSidebar.vue";
import SearchFacets from "@/components/SearchFacets.vue";
import StringFilterModal from "@/components/Filter/StringFilterModal.vue";

import { createMapper } from "@/utils/mapping.js";

import { debounce } from "@/utils/misc.js";

import config from "@/config.json";

const mapper = createMapper("tagsearch-form");

export default {
  components: {
    SearchLayout,
    SearchSidebar,
    SearchFacets,
    StringFilterModal,
  },
  watch: {
    activeTab() {
      this.$router.push({ query: {} });
    },
    currentPage: {
      handler: function() {
        const query = { ...this.$route.query };
        query[mapper.toURL("page")] = this.currentPage;
        this.$router.push({ query });
      },
    },
    tags: {
      handler: function() {
        const query = { ...this.$route.query };
        let typeArray = this.tags.map(function(obj) {
          if (obj != null) {
            return obj.value;
          }
        });
        typeArray = typeArray.filter(function(el) {
          return el != null;
        });
        query[mapper.toURL("type")] = typeArray;
        this.$router.push({ query });
      },
    },
    "$route.query": {
      handler: "update",
      // NOTE: should NOT run before children's watchers
      immediate: false,
    },
  },
  data() {
    return {
      activeTab: 0,
      isOpen: false,
      metaFacets: null,
      facets: [],
      facetValues: [],
      isLoading: false,
      results: null,
      currentPage: 1,
      currentTypes: [],
      itemsPerPage: 10,
      total: NaN,
      filterFacets: [],
      attributes: [],
      confAttr: config.attributes,
    };
  },
  async mounted() {
    await this.load();
  },
  computed: {
    layout() {
      const { term } = this.query;
      return !term ? "narrow" : "sidebar";
    },
    query() {
      return mapper.fromURL(this.$route.query);
    },
    pagesTotal() {
      return Math.ceil(this.total / this.itemsPerPage);
    },
    searchResultRoutes() {
      return this.results.map((result) => ({
        name: "Browser",
        params: {
          documentId: result.dId,
          pageNum: result.pageNr,
        },
        query: mapper.toURL({
          term: result.value,
        }),
      }));
    },
    offset() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    limit() {
      return this.itemsPerPage;
    },
    params() {
      return { offset: this.offset, limit: this.limit };
    },
    metaFields() {
      return config.meta;
    },
    groupDocId() {
      return 1
    }
  },
  methods: {
    load: debounce(async function() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      const { total, results, items, facets } = await this.fetchNextPage();

      this.facets = facets;
      this.results = items;

      this.total = total;
      this.isLoading = false;
      this.filterFacets = [];
    }, 50),
    update(query, prevQuery = {}) {
      let mustReload = false;
      let mustResetPage = true;
      let mustReset = false;

      for (var meta in this.metaFields) {
        var field = this.metaFields[meta];
        if (query[field] != prevQuery[field]) {
          mustReload = true;
          var obj = { value: query[field], field: field };
          if (query[field]) {
            this.filterFacets.push(obj);
          }
        }
      }

      if (query["v"] != prevQuery["v"]) {
        mustReload = true;
      }

      if (query["p"] != prevQuery["p"]) {
        mustReload = true;
        mustResetPage = false;
      }

      if (mustReload) {
        this.load();
      }
    },
    facetLableSelect(option) {
      return this.$t(Object.keys(option)[0]);
    },
    facetLable(option) {
      return Object.keys(option)[0];
    },
    resetPage() {
      this.$router.push({
        query: omit(this.$route.query, this.QUERY.PAGE),
      });
    },
    reset() {
      this.$router.push({
        query: omit(this.$route.query, [this.QUERY.TERM, this.QUERY.PAGE]),
      });

      this.results = null;
    },
    scroll() {
      this.$nextTick(() => (document.documentElement.scrollTop = 0));
    },
    openModal(option, label) {
      var items = option[Object.keys(option)[0]];
      var modal = this.$buefy.modal.open({
        parent: this,

        component: StringFilterModal,
        events: {
          closeModal: (value) => {
            option.label = value;
            modal.close();
          },
        },
        trapFocus: true,
        destroyOnHide: false,
        props: {
          items: items,
          name: label,
          label: label,
        },
      });
    },

    async fetchNextPage() {
      if (this.error !== null) {
        this.error = null;
      }
      try {
        return await this.api.fetchMetaFacets(
          {
            ...this.query,
            facetArr: this.metaFields,
            filterFacets: this.filterFacets,
            groupDocId : 1
          },
          this.params
        );
      } catch (err) {
        this.error = err.message;
      }
    },
  },
};
</script>
